import { CPNIModal } from 'components/account/privacy/cpni-modal';
import { withModal } from 'components/common/modal/withModal';
import { compose } from 'redux';

const enhance = compose(withModal);
const CPNIModalContainer = enhance(CPNIModal);

export { CPNIModalContainer };
